import React, { FC, useEffect } from 'react';
import useScrollToSection from '@hooks/useScrollToSection';
import useTranslations from '@hooks/useTranslation';
import Title, { TitleTagTypes } from '@ui/SectionTitle/Title';
import ContentTemplate from '../../ui/Content/Content';
import TeamPersonTemplate from '../../ui/TeamPerson/TeamPerson';
import { Persons } from './Team.elements';

export interface TeamProps { }

export const TEAMS = [
    {
        image: '/a_zizka.webp',
        name: 'Alexandra Žižka',
        position: 'Manažerka vzdělávání',
        phones: ['+420 739 213 778'] as string[],
        mail: 'zizka@pp.cz',
    },
    {
        image: '/k_hajkova.webp',
        name: 'Kateřina Hájková',
        position: 'Manažerka obchodního rozvoje a strategických partnerství',
        phones: ['+420 737 011 296'] as string[],
        mail: 'hajkova@pp.cz',
    },
    {
        image: '/z_rajchartova.webp',
        name: 'Vanesa Rajchartová',
        position: 'Produktová manažerka – mzdy, pracovní právo, personalistika a veřejná správa',
        phones: ['+420 734 156 851'] as string[],
        mail: 'rajchartova@pp.cz',
    },
    {
        image: '/z_polivkova.jpg',
        name: 'Gabriela Polívková',
        position: 'Produktová manažerka - daně, účetnictví a finance',
        phones: ['+420 602 245 664'] as string[],
        mail: 'polivkova@pp.cz',
    },
    {
        image: '/z_jureckova.webp',
        name: 'Šárka Jurečková',
        position: 'Produktová manažerka - soft skills, firemní kurzy na míru',
        phones: ['+420 602 398 155'] as string[],
        mail: 'jureckova@pp.cz',
    },
    
    {
        image: '/z_abelova.webp',
        name: 'Veronika Ábelová',
        position: 'Marketingová specialistka',
        phones: ['+420 737 936 574'] as string[],
        mail: 'abelova@pp.cz',
    },
    {
        image: '/z_blahutova.webp',
        name: 'Miluše Blahutová',
        position: 'Manažerka klientských služeb',
        phones: ['+420 212 247 811'] as string[],
        mail: 'blahutova@pp.cz',
    },
    {
        image: '/z_salimova.webp',
        name: 'Elizabeth Salimova',
        position: 'Specialistka klientské péče',
        phones: ['+420 212 247 824'] as string[],
        mail: 'salimova@pp.cz',
    }
];

const TeamTemplate: FC<TeamProps> = () => {
    const { t } = useTranslations();

    useScrollToSection('nas-tym', 'nastym');

    return (
        <ContentTemplate withPadding id="nastym" mobileSidePadding={20}>
            <Title tagType={TitleTagTypes.H3} isBlack>
                {t('contact.team.title')}
            </Title>
            <Persons>
                {TEAMS.map((person, personKey) => (
                    <TeamPersonTemplate
                        key={personKey}
                        personKey={personKey}
                        image={person.image}
                        name={person.name}
                        position={person.position}
                        phones={person.phones}
                        mail={person.mail}
                    />
                ))}
            </Persons>
        </ContentTemplate>
    );
};

export default TeamTemplate;
